import { useObserver } from "mobx-react";
import { MdDelete } from "react-icons/md";
import { MdSearch } from "react-icons/md";
import { useStores } from "../../../store";
import { ConvertTimeStamptoDate } from "../../../services/reusable";
import PdfViewer from "../../reusble_components/pdfViewer";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import noRecords from "../../../assests/noRecords.png";

export default function PreviousResults() {
  const { UserStore, CommonStore } = useStores();
  const [loader, setLoader] = useState(false);
  const rowBoxes = [
    {
      width: "22.5%", // Placeholder for 'Name' in row
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "15%", // Placeholder for 'Email ID' in row
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "25%", // Placeholder for 'Applied Date' in row
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "15%", // Placeholder for 'Applied for' in row
      height: "1.2rem",
      shape: "rectangle",
    },
    {
      width: "10%", // Placeholder for 'Total Score' in row
      height: "1.2rem",
      shape: "rectangle",
    },
  ];
  const handlePageClick = (data) => {
    const selected = data.selected;
    UserStore.getAllPreviousResumes(selected * 10);
  };

  const navigation = useNavigate();

  return useObserver(() => (
    <div className=" md:my-0 p-4 md:p-10">
      {CommonStore.resume && (
        <PdfViewer
          pdfUrl={CommonStore.jobresume}
          onClose={() => CommonStore.setResume(false)}
        />
      )}
      {/* Search Box */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold min-w-fit pr-4 md:pr-0 ">
          Previous Results
        </h2>
        <div className="relative">
          <input
            type="text"
            placeholder="Search"
            className="border border-primary rounded-lg py-2 pl-10 pr-4 focus:outline-none focus:ring-2 focus:ring-orange-400"
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                UserStore.setResumeSearch(e.target.value);
                UserStore.getAllPreviousResumes(0);
              }
            }}
            onBlur={(e) => {
              if (e.target.value === "") {
                UserStore.setResumeSearch("");
                UserStore.getAllPreviousResumes(0);
              }
            }}
          />
          <MdSearch
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary"
            size={20}
          />
        </div>
      </div>

      {UserStore.PreviousResumes.length > 0 || UserStore.loader ? (
        <div className="overflow-x-auto">
          <table className="min-w-full rounded-2xl ">
            <thead>
              <tr className="bg-[#FEEFD6BF] text-center !rounded-2xl">
                <th className="p-3 ">Job post name</th>
                <th className="p-3 ">Date</th>
                <th className="p-3 ">File name</th>
                <th className="p-3 ">overallscore</th>
                <th className="p-3 ">More Options</th>
              </tr>
            </thead>
            <tbody>
              {UserStore.loader &&
                Array.from({ length: 10 }).map((_, index) => (
                  <tr
                    key={index}
                    className="border-b items-center justify-center font-bold text-primary text-xl text-center"
                  >
                    <td colSpan="8" className="py-2">
                      <div
                        className={`bg-gray-100 flex items-center rounded-lg py-3 px-5 shadow-md animate-pulse`}
                        style={{ height: "4rem" }}
                      >
                        <div
                          className={`flex-1 ${
                            true && "" !== "resumescore" ? "ml-4" : ""
                          } flex w-full justify-around`}
                        >
                          {rowBoxes.map((rowBox, idx) => (
                            <div
                              key={idx}
                              className={`bg-gray-300 ${
                                rowBox.shape === "rectangle"
                                  ? "rounded-md"
                                  : "rounded-full"
                              } mx-2`}
                              style={{
                                width: rowBox.width,
                                height: rowBox.height,
                              }}
                            ></div>
                          ))}
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              {UserStore.PreviousResumes?.map((Resume, index) => (
                <tr
                  key={index}
                  className="border-b hover:bg-gray-100 text-center cursor-pointer"
                  onClick={() => {
                    navigation(
                      `/dashboard/resume-analyzer-report?id=${Resume._id}`
                    );
                  }}
                >
                  <td className="p-3">{Resume?.name ?? Resume._id}</td>
                  <td className="p-3">
                    {ConvertTimeStamptoDate(Resume?.createdAt)}
                  </td>
                  <td
                    className="p-3 text-blue-500 cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (Resume?.resume) {
                        CommonStore.setJobResume(Resume?.resume);
                        CommonStore.setResume(true);
                      }
                    }}
                  >
                    {Resume?.resume ? Resume?.resume?.split("/").pop() : "NA"}
                  </td>
                  <td className="p-3">{Resume?.score}%</td>
                  <td className="p-3">
                    <button
                      className="text-gray-600 hover:text-primary"
                      onClick={(e) => {
                        e.stopPropagation();
                        const res=window.confirm("Are you sure you want to delete this resume?")
                        if(res)
                        {
                          setLoader(true);
                          UserStore.deleteResume(Resume._id);
                          setLoader(false);
                        }
                      }}
                    >
                      <MdDelete size={20} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {UserStore.PreviousResumesCount > 10 && (
            <div>
              <ReactPaginate
                nextLabel=" >"
                className="flex justify-center items-center gap-5 my-4"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={UserStore.PreviousResumesCount / 10}
                previousLabel="< "
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName="active-page-item"
                activeLinkClassName="active-page-link"
                renderOnZeroPageCount={null}
                // forcePage={currentPage}
              />
            </div>
          )}
        </div>
      ) : (
        <div className="flex justify-center items-center h-96">
          <img src={noRecords} alt="No Records" className="" />
        </div>
      )}
    </div>
  ));
}
